import { Api } from "./international";

/**
 * 创建出口合规审查单。
 */
export const createComplianceReview = params =>
  Api.post("/partners-customer-service/export-compliance/review/create", params);



// WEBPACK FOOTER //
// ./src/api/compliance.js